var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EmptyView,{attrs:{"name":_setup.t('spreed', 'You do not have permissions to access this conversation.'),"description":_setup.t('spreed', 'Join a different conversation or start a new one.')},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c(_setup.Octagon)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }